import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'splitTranslation'
})
export class SplitTranslationPipe implements PipeTransform {
  transform(value: string, index: number): string {
    const splitValue = value.split('|')
    if (index > splitValue.length - 1) {
      return ''
    }

    return splitValue[index]
  }
}
